<template>
  <div class="header-nav flex-col">
    <div class="header-content flex-row">
      <img
        v-if="siteConfig && siteConfig.logo"
        class="header-logo"
        :src="getImageUrl(siteConfig.logo)"
        referrerpolicy="no-referrer"
        alt="logo"
      />
      <img
        v-else
        class="header-logo"
        referrerpolicy="no-referrer"
        src="../assets/img/logo.png"
      />
      <span class="header-title">正定县常山陵园</span>
      <div class="header-phone-icon flex-col">
        <img
          class="header-phone-label"
          referrerpolicy="no-referrer"
          src="../assets/img/phone-icon.png"
        />
      </div>
      <div class="header-phone-text flex-col justify-between">
        <span class="header-phone-title">官方热线</span>
        <span class="header-phone-number">{{ siteConfig?.tel || '021-59506101' }}</span>
      </div>
      <div class="header-auth flex-row">
        <router-link 
          v-if="!isLoggedIn" 
          to="/login" 
          class="header-login-btn"
        >
          登录
        </router-link>
        <div v-else class="header-user-actions flex-row">
          <router-link 
            to="/user-center" 
            class="header-user-center-btn"
          >
            个人中心
          </router-link>
          <button 
            @click="handleLogout" 
            class="header-logout-btn"
          >
            退出登录
          </button>
        </div>
      </div>
    </div>
    <div class="header-divider flex-col"></div>
    <div class="header-menu flex-row">
      <router-link to="/lanhu_shouye" class="menu-item" :class="{ active: currentPath === '/lanhu_shouye' || currentPath === '/' }" active-class="" exact-active-class="">首页</router-link>
      <div class="menu-divider flex-col"></div>
      <router-link to="/lanhu_guanyuwomen" class="menu-item" :class="{ active: currentPath === '/lanhu_guanyuwomen' }" active-class="" exact-active-class="">关于我们</router-link>
      <div class="menu-divider flex-col"></div>
      <router-link to="/service" class="menu-item" :class="{ active: currentPath === '/service' }" active-class="" exact-active-class="">服务项目</router-link>
      <div class="menu-divider flex-col"></div>
      <router-link to="/news" class="menu-item" :class="{ active: currentPath === '/news' || currentPath.startsWith('/news/') }" active-class="" exact-active-class="">新闻资讯</router-link>
      <div class="menu-divider flex-col"></div>
      <router-link to="/reserve" class="menu-item" :class="{ active: currentPath === '/reserve' }" active-class="" exact-active-class="">预约咨询</router-link>
      <div class="menu-divider flex-col"></div>
      <router-link to="/lanhu_muxingzhanshi" class="menu-item" :class="{ active: currentPath === '/lanhu_muxingzhanshi' }" active-class="" exact-active-class="">墓型展示</router-link>
      <div class="menu-divider flex-col"></div>
      <router-link to="/lanhu_zaixianjidian" class="menu-item" :class="{ active: currentPath === '/lanhu_zaixianjidian' }" active-class="" exact-active-class="">人文纪念</router-link>
      <div class="menu-divider flex-col"></div>
      <router-link to="/lanhu_zaixiangoumu" class="menu-item" :class="{ active: currentPath === '/lanhu_zaixiangoumu' }" active-class="" exact-active-class="">在线购墓</router-link>
    </div>
  </div>
</template>

<script>
import { getSiteConfig } from '@/store/siteConfig'
import { getImageUrl } from '@/config/api'
import { isLoggedIn, removeToken } from '@/api/auth'

export default {
  name: 'HeaderNav',
  data() {
    return {
      siteConfig: null,
      isLoggedIn: false
    }
  },
  computed: {
    currentPath() {
      return this.$route.path;
    }
  },
  created() {
    // 获取网站配置
    this.siteConfig = getSiteConfig()
    // 检查登录状态
    this.checkLoginStatus()
  },
  watch: {
    // 监听路由变化，更新登录状态
    '$route'() {
      this.checkLoginStatus()
    }
  },
  methods: {
    getImageUrl(imgPath) {
      return getImageUrl(imgPath)
    },
    checkLoginStatus() {
      this.isLoggedIn = isLoggedIn()
    },
    handleLogout() {
      // 退出登录
      removeToken()
      this.isLoggedIn = false
      // 如果当前在需要登录的页面，跳转到首页
      if (this.$route.meta.requiresAuth) {
        this.$router.push('/')
      }
      // 提示用户
      if (this.$toast) {
        this.$toast.success('已退出登录')
      }
    }
  }
};
</script>

<style scoped>
.header-nav {
  position: absolute !important; /* 使用 !important 确保样式优先级 */
  /* left: 30px; */
  top: 0 !important;
  width: 100% !important;
  max-width: 1920px !important;
  height: auto !important;
  min-height: 150px !important;
  background-color: rgba(255, 255, 255, 0.95) !important; /* 添加背景色作为后备，避免背景图加载前显示异常 */
  background-image: url(../assets/img/header-bg.png) !important;
  background-position: -30px 0px !important;
  background-repeat: no-repeat !important;
  background-size: cover !important;
  left: 0 !important;
  right: 0 !important;
  margin: 0 auto !important;
  box-sizing: border-box !important;
  z-index: 100 !important; /* 确保 HeaderNav 在最上层 */
  /* 防止 flexible.js 影响布局 */
  font-size: initial !important;
}

.header-content {
  width: 100%;
  max-width: 1200px;
  height: auto;
  min-height: 56px;
  margin: 22px auto 0;
  padding: 0 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
}

.header-logo {
  width: 74px;
  height: 56px;
  flex-shrink: 0;
  align-self: center;
}

.header-title {
  width: auto;
  min-width: 0;
  height: auto;
  overflow-wrap: break-word;
  color: rgba(0, 149, 151, 1);
  font-size: 40px;
  font-family: duanningmaobixingsu;
  text-align: left;
  white-space: nowrap;
  line-height: 1.2;
  margin: 0 0 0 10px;
  align-self: center;
}

.header-phone-icon {
  border-radius: 50%;
  height: 44px;
  border: 2px solid rgba(140, 48, 0, 1);
  width: 44px;
  margin: 0 0 0 auto;
  flex-shrink: 0;
  align-self: center;
  justify-content: center;
}

.header-phone-label {
  width: 22px;
  height: 24px;
  margin: 10px 0 0 11px;
}

.header-phone-text {
  width: 189px;
  height: 52px;
  margin: 0 0 0 10px;
  align-self: center;
}

.header-phone-title {
  width: 61px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(0, 0, 0, 1);
  font-size: 16px;
  font-family: AlibabaPuHuiTi_2_65_Medium;
  text-align: left;
  white-space: nowrap;
  line-height: 16px;
}

.header-phone-number {
  width: 189px;
  height: 21px;
  overflow-wrap: break-word;
  color: rgba(140, 48, 0, 1);
  font-size: 28px;
  font-family: SourceHanSansCN-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 28px;
  margin-top: 16px;
}

.header-auth {
  margin-left: 20px;
  align-items: center;
  align-self: center;
}

.header-login-btn,
.header-logout-btn,
.header-user-center-btn {
  padding: 6px 20px;
  border: 1px solid rgba(0, 149, 151, 1);
  border-radius: 4px;
  background-color: transparent;
  color: rgba(0, 149, 151, 1);
  font-size: 14px;
  font-family: AlibabaPuHuiTi_2_55_Regular;
  cursor: pointer;
  text-decoration: none;
  transition: all 0.3s;
  white-space: nowrap;
}

.header-login-btn:hover,
.header-logout-btn:hover,
.header-user-center-btn:hover {
  background-color: rgba(0, 149, 151, 1);
  color: #ffffff;
}

.header-login-btn:active,
.header-logout-btn:active,
.header-user-center-btn:active {
  opacity: 0.8;
}

.header-user-actions {
  align-items: center;
  gap: 10px;
}

.header-divider {
  background-color: rgba(222, 222, 222, 1);
  width: 100%;
  height: 1px;
  margin: 22px 0 0 0;
}

.header-menu {
  width: 100%;
  max-width: 1212px;
  height: auto;
  min-height: 18px;
  margin: 18px auto 13px;
  padding: 0 20px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}

.menu-item {
  height: 17px;
  overflow-wrap: break-word;
  color: rgba(92, 92, 92, 1);
  font-size: 18px;
  font-family: AlibabaPuHuiTi_2_55_Regular;
  text-align: left;
  white-space: nowrap;
  line-height: 18px;
  text-decoration: none;
  cursor: pointer;
  position: relative;
  display: inline-block;
}

.menu-item:hover,
.menu-item.active {
  color: rgba(0, 149, 151, 1);
  font-family: AlibabaPuHuiTi_2_65_Medium;
}

/* 只有 .active 类才显示下划线，确保精确匹配 */
.menu-item.active::after {
  content: '';
  position: absolute;
  bottom: -13px;
  left: 0;
  width: 100%;
  height: 4px;
  background-color: rgba(0, 149, 151, 1);
}

/* 完全禁用 Vue Router 自动类的样式，避免多个链接同时被选中 */
/* 只有同时有 .active 类的才显示选中样式，其他情况一律禁用 */
.menu-item.router-link-active:not(.active),
.menu-item.router-link-exact-active:not(.active) {
  color: rgba(92, 92, 92, 1) !important;
  font-family: AlibabaPuHuiTi_2_55_Regular !important;
}

.menu-item.router-link-active:not(.active)::after,
.menu-item.router-link-exact-active:not(.active)::after {
  display: none !important;
  content: none !important;
}

/* 确保只有 .active 类才显示选中样式 */
.menu-item:not(.active) {
  color: rgba(92, 92, 92, 1);
}

.menu-item:not(.active)::after {
  display: none !important;
  content: none !important;
}

.menu-divider {
  background-color: rgba(222, 222, 222, 1);
  width: 1px;
  height: 18px;
  margin: 0 35px;
}

/* 移动端适配 */
@media screen and (max-width: 768px) {
  .header-nav {
    position: relative !important;
    width: 100% !important;
    left: 0 !important;
    height: auto !important;
    background-size: cover !important;
    padding: 10px 0 !important;
  }

  .header-content {
    width: 100% !important;
    margin: 10px 0 !important;
    padding: 0 10px !important;
    flex-wrap: wrap !important;
    justify-content: space-between !important;
    align-items: center !important;
  }

  .header-logo {
    width: 50px !important;
    height: 38px !important;
  }

  .header-title {
    font-size: 20px !important;
    margin: 0 0 0 10px !important;
    flex: 1 !important;
    white-space: normal !important;
  }

  .header-phone-icon {
    margin: 0 10px 0 0 !important;
    margin-left: auto !important;
    width: 36px !important;
    height: 36px !important;
  }

  .header-phone-label {
    width: 18px !important;
    height: 20px !important;
    margin: 8px 0 0 9px !important;
  }

  .header-phone-text {
    display: none !important; /* 移动端隐藏电话号码文字 */
  }

  .header-auth {
    margin-left: 10px !important;
    margin-top: 0 !important;
  }

  .header-login-btn,
  .header-logout-btn {
    padding: 4px 12px !important;
    font-size: 12px !important;
  }

  .header-divider {
    width: 100% !important;
    margin: 10px 0 !important;
  }

  .header-menu {
    width: 100% !important;
    margin: 10px 0 !important;
    padding: 0 10px !important;
    flex-wrap: wrap !important;
    justify-content: center !important;
    height: auto !important;
  }

  .menu-item {
    font-size: 14px !important;
    margin: 5px 8px !important;
    padding: 5px 10px !important;
  }

  .menu-divider {
    display: none !important;
  }
}
</style>


